import React from "react";
import "../css/CurriculumPageComponent.scss";
import BannerComponent from "./BannerComponent";
import CurriculumBannerImage from '../assets/WhatsApp Image 2024-09-20 at 05.46.09_e22ce82b.png';
import CaretRightImage from '../assets/Group.png';
import EllipseImage from '../assets/Ellipse 16.png';
import { PiBookOpenText } from "react-icons/pi";
import PaintImage from '../assets/Paint palette.png';
import NumbersImage from '../assets/Numbers.png';
import MilkImage from '../assets/Milk.png';
import ComputerImage from '../assets/Computer.png';
import MathsImage from '../assets/Mathematics.png';
import ScienceImage from '../assets/Chemical.png';
import HandPrint from '../assets/Hand print.png'

const curriculumFeatures = [
  {
    img: EllipseImage,
    title: "Holistic Development:",
    description: "Ensuring a balance between academic excellence, creative expression, and physical well-being."
  },
  {
    img: EllipseImage,
    title: "Inquiry-Based Learning:",
    description: "Encouraging love for learning by allowing students to explore concepts through questioning and experimentation."
  },
  {
    img: EllipseImage,
    title: "21st Century Skills:",
    description: "Equipping students with skills such as collaboration, digital literacy, and adaptability, preparing them for the world."
  }
];

const nurserySubjects = [
  {
    img: NumbersImage,
    title: "Numeracy",
    description: "Developing number sense through counting, shapes, and patterns."
  },
  {
    img: MilkImage,
    title: "Literacy & Language",
    description: "Building early reading, writing, and communication skills through stories and interactive play."
  },
  {
    img: PaintImage,
    title: "Creative Arts",
    description: "Art, music, and role-playing activities that encourage creativity and self-expression."
  }
];

const primarySubjects = [
  {
    img: MilkImage,
    title: "English Language",
    description: "Developing reading, writing, speaking, and listening skills for confident communication."
  },
  {
    img: MathsImage,
    title: "Mathematics",
    description: "Focus on problem-solving, reasoning, and arithmetic."
  },
  {
    img: ScienceImage,
    title: "Basic Science & Technology",
    description: "An integrated subject combining Science, Technology, ICT, and Geography through hands-on exploration."
  },
  {
    img: HandPrint,
    title: "Physical & Health Education",
    description: "Promoting fitness, teamwork, and healthy habits through structured physical activity."
  }
];

const enrichmentClasses = ["Voice & Diction", "Inclusion", "French", "Chess", "Music", "Robotics", "Coding"];
const extraCurricularClubs = ["Taekwondo", "Swimming", "Ballet", "Music", "Red Cross"];

const CurriculumPageComponent = () => {
  return (
    <div>
      <BannerComponent
        title='Inspiring young minds for tomorrow’s world'
        image={CurriculumBannerImage}
        description='Nurturing creativity, curiosity, and lifelong learning through a balanced and engaging curriculum'
        buttonInformation={
          <>
            <a href="/about">Learn More <PiBookOpenText /></a>
          </>
        }
      />

      <div className="page-width">
        <div className="overview">
          <div className='overview-header'>
            Curriculum Overview <img className='caret' src={CaretRightImage} alt='caret-right'/>
          </div>
          <p className="overview-description">
            Here, at The HoneyRock School, we believe that education goes beyond textbooks and exams.
            Our curriculum is designed to nurture well-rounded individuals who are not only academically proficient
            but also creative, empathetic, and prepared for the challenges of the future. Through a balanced approach
            to learning, we ensure that every student develops critical thinking, problem-solving, and social skills.
          </p>

          <header className='overview-sub-header'>Educational Philosophy</header>
          <p className="philosophy-header">
            Our curriculum is rooted in the belief that each child is unique and has the potential to excel. We focus on:
          </p>
          <ul className='features'>
            {curriculumFeatures.map((feature, index) => (
              <li className='ftr' key={index}>
                <img src={feature.img} className="ellipse" alt="ellipse"/>
                <span>{feature.title}</span> {feature.description}
              </li>
            ))}
          </ul>
        </div>

        <div className="subject-content">
          <header className="subject-container-header">Nursery / Preschool Subjects</header>
          <p className="curriculum-framework">Framework: <strong>EYFS (Early Years Foundation Stage)</strong></p>
          <div className="subject-container">
            {nurserySubjects.map((subject, index) => (
              <div className="subject" key={index}>
                <div className="subject-image-container">
                  <img src={subject.img} className="subject-image" alt="subject-jpeg" />
                </div>
                <div className="subject-text-container">
                  <header className="subject-header">{subject.title}</header>
                  <p className="subject-description">{subject.description}</p>
                </div>
              </div>
            ))}
          </div>

          <header className="subject-container-header">Primary Subjects</header>
          <p className="curriculum-framework">Framework: <strong>Blended Nigerian and British Curriculum</strong></p>
          <div className="subject-container subject-container--four">
            {primarySubjects.map((subject, index) => (
              <div className="subject" key={index}>
                <div className="subject-image-container">
                  <img src={subject.img} className="subject-image" alt="subject-jpeg"/>
                </div>
                <div className="subject-text-container">
                  <header className="subject-header">{subject.title}</header>
                  <p className="subject-description">{subject.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="enrichment-content">
          <header className="subject-container-header">Enrichment &amp; Extra-Curricular</header>
          <div className="enrichment-grid">
            <div className="enrichment-card">
              <h3 className="enrichment-card-title">Enrichment Classes</h3>
              <ul className="enrichment-list">
                {enrichmentClasses.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
            <div className="enrichment-card">
              <h3 className="enrichment-card-title">Extra-Curricular Clubs</h3>
              <ul className="enrichment-list">
                {extraCurricularClubs.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurriculumPageComponent;
